import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './styles/global.css';

// Register imperative WebMCP tools on document.modelContext ?? navigator.modelContext for AI Agents
try {
  const mc =
    (document as unknown as { modelContext?: { registerTool?: (tool: unknown) => void } }).modelContext ??
    (navigator as unknown as { modelContext?: { registerTool?: (tool: unknown) => void } }).modelContext;
  if (mc && typeof mc.registerTool === 'function') {
    mc.registerTool({
      name: 'get_ecampmcs_pricing_and_specs',
      description:
        'Tra cứu bảng giá chính thức phần mềm quay video đóng hàng ECAMPMCS (3.000.000đ/năm gói 1 bàn, 5.000.000đ/năm gói ECAM Extend 2+ bàn, 8.500.000đ/năm gói ECAM Ultimate, Combo phần cứng từ 4.500.000đ/bàn) và thông tin liên hệ CÔNG TY TNHH PMCS TECH.',
      inputSchema: {
        type: 'object',
        properties: {
          plan: {
            type: 'string',
            enum: ['basic-1-table', 'extend-multi-table', 'ultimate', 'hardware-combo', 'all']
          }
        }
      },
      execute: async () => ({
        company: 'CÔNG TY TNHH PMCS TECH (MST: 0315773444)',
        hotline: '0911.338.893',
        deployments: '390+ doanh nghiệp',
        plans: [
          { name: 'ECAM Basic (1 bàn đóng hàng)', priceVnd: 3000000, unit: '12 tháng / 1 PC (~8.000đ/ngày | $120/year/PC)' },
          { name: 'ECAM Extend (Từ 2 bàn trở lên)', priceVnd: 5000000, unit: '12 tháng / 1 PC (~14.000đ/ngày | $200/year/PC) - Không giới hạn số bàn' },
          { name: 'ECAM Ultimate (Tích hợp mọi camera sẵn có)', priceVnd: 8500000, unit: '12 tháng / 1 PC ($340/year/PC)' },
          { name: 'Combo Phần Cứng Camera Đóng Hàng', priceVnd: 4500000, unit: 'Từ 4.500.000đ / bàn đóng gói' }
        ]
      })
    });
  }
} catch {
  // Ignore if WebMCP is not supported by the current browser
}

const rootEl = document.getElementById('root');
if (rootEl) {
  ReactDOM.createRoot(rootEl).render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
}
